<template>
  <div class="content">
    <div class="top clearfix">
      <router-link to="home" style="color: #999">登游首页&nbsp;</router-link>
      <router-link to="about" style="color: #999">关于登游&nbsp;</router-link>
      <router-link to="product" style="color: #999">游戏产品&nbsp;</router-link>
      <router-link to="business" style="color: #999"
        >商务合作&nbsp;</router-link
      >
      <router-link to="join" style="color: #999">加入我们&nbsp;</router-link>
      <!-- <a style="color: #999;font-size:16px;" href="https://m.kuaidi100.com/" target="_blank">快递查询</a> -->
      <!-- <router-link to='' style="color: #999;">服务条款&nbsp;</router-link> -->
      <!-- <router-link to='Privacy' style="color: #999;">隐私保护指引&nbsp;</router-link> -->
    </div>
    <div class="center">
      <a
        href="http://www.beian.miit.gov.cn"
        target="_blank"
        style="text-decoration: none"
      >
        <span>闽ICP备2022001053号</span>
      </a>
      <span>COPYRIGHT ©</span>
      <span
        >2017 – {{ new Date().getFullYear() }} 登游科技. ALL RIGHTS
        RESERVED</span
      >
    </div>
    <div class="bottom">
      <span>厦门登游科技有限公司 版权所有</span>
    </div>
    <div>
      <p>健康游戏忠告</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      listLoader: [
        "关于",
        "服务条款",
        "隐私保护指引",
        "加入我们",
        "成长守护平台",
        "商务合作",
      ],
      list: [
        "闽ICP备17013745号-1 ",
        "COPYRIGHT © ",
        ` 2017 – ${new Date().getFullYear()}  登游科技. ALL RIGHTS RESERVED`,
      ],
    };
  },
};
</script>

<style>
.content {
  width: 100%;
  background-color: rgb(72, 72, 72);
  padding: 0.3125rem 0;
}
.top {
  display: flex;
  justify-content: center;
  width: -webkit-fit-content;
  margin: 5.9375rem auto 0.7rem;
}
span {
  color: #999;
  font-size: 0.9375rem;
}
.bottom {
  margin: 0.7rem auto 5rem;
}
@media screen and (max-width: 472px) {
  .top {
    display: block;
  }
  span {
    display: block;
  }
}
</style>
